import { useEffect, useState } from 'react';

const storageKey = (tab, field) => `admin-course-list:${tab}:${field}`;

export function readCourseListSession(tab, field, fallback) {
  try {
    const stored = window.sessionStorage.getItem(storageKey(tab, field));
    if (stored == null) return fallback;
    const value = JSON.parse(stored);
    if (typeof fallback === 'number') {
      if (field === 'pageSize') return [10, 25, 50, 100].includes(value) ? value : fallback;
      return Number.isInteger(value) && value > 0 ? value : fallback;
    }
    if (typeof fallback === 'string') {
      return typeof value === 'string' ? value : fallback;
    }
    if (Array.isArray(fallback)) {
      return Array.isArray(value) ? value : fallback;
    }
    return fallback;
  } catch {
    return fallback;
  }
}

export function writeCourseListSession(tab, field, value) {
  try {
    window.sessionStorage.setItem(storageKey(tab, field), JSON.stringify(value));
  } catch {
    // Browsing still works when session storage is unavailable.
  }
}

export function useCourseListSessionState(tab, field, fallback) {
  const [value, setValue] = useState(() => readCourseListSession(tab, field, fallback));

  useEffect(() => {
    writeCourseListSession(tab, field, value);
  }, [tab, field, value]);

  return [value, setValue];
}
